<template>
  <div class="matching-form-content">
    <div class="containerPage">
      <div>
        <Transition name="fade">
          <img src="../assets/specialitiesMatching.png" alt="Kaffea Terra Gifts" class="gifts" v-if="showImage">
        </Transition>
        <form ref="contactForm" @submit.prevent="handleSubmit" class="containerForm">
        <div class="formTitle">
          {{ $t('formPage.formTitle') }}
        </div>
        <div class="mb-[2vw] flex gap-[2vw]">
          <input type="text" id="fname" :value="userInfo.fname" @input="updateFName($event.target.value)" required
            class="text-[4.5vw] bg-[#F0F0F0] text-[#101B53] border-none rounded-[100vw] block w-1/2 py-[1.25vw] px-[3vw] focus:ring-[#101B53] focus:border-[#101B53]"
            :placeholder="$t('formPage.fnamePlaceholder')" />

          <input type="text" id="lname" :value="userInfo.lname" @input="updateLName($event.target.value)" required
            class="text-[4.5vw] bg-[#F0F0F0] text-[#101B53] border-none rounded-[100vw] block w-1/2 py-[1.25vw] px-[3vw] focus:ring-[#101B53] focus:border-[#101B53]"
            :placeholder="$t('formPage.lnamePlaceholder')" />
        </div>
        <div class="mb-[2vw]">
          <input type="email" id="email" ref="emailInput" :value="userInfo.email" @input="updateEmail($event)"
            @blur="validateEmailField" required inputmode="email" autocomplete="email" maxlength="254"
            :aria-invalid="emailTouched && !isEmailValid" aria-describedby="email-error"
            class="text-[4.5vw] bg-[#F0F0F0] text-[#101B53] border-none rounded-[100vw] block w-full py-[1.25vw] px-[3vw] focus:ring-[#101B53] focus:border-[#101B53]"
            :placeholder="$t('formPage.emailPlaceholder')" />
          <p v-if="emailTouched && !isEmailValid" id="email-error" class="mt-2 px-[3vw] text-[2.5vw] text-red-600"
            role="alert">
            {{ $t('formPage.emailError') }}
          </p>
        </div>
        <div class="mb-[2vw]">
          <input type="tel" id="phone" ref="phoneInput" :value="userInfo.phone" @input="updatePhone($event)"
            @blur="validatePhoneField" required inputmode="tel" autocomplete="tel" maxlength="20"
            pattern="[+]?[0-9 ()-]{7,20}" :aria-invalid="phoneTouched && !isPhoneValid" aria-describedby="phone-error"
            class="text-[4.5vw] bg-[#F0F0F0] text-[#101B53] border-none rounded-[100vw] block w-full py-[1.25vw] px-[3vw] focus:ring-[#101B53] focus:border-[#101B53]"
            :placeholder="$t('formPage.phonePlaceholder')" />
          <p v-if="phoneTouched && !isPhoneValid" id="phone-error" class="mt-2 px-[3vw] text-[2.5vw] text-red-600"
            role="alert">
            {{ $t('formPage.phoneError') }}
          </p>
        </div>
        <div class="gdprLabel flex mb-[70px]">
          <div class="flex">
            <input id="gdpr" type="checkbox" name="gdpr" :checked="userInfo.acceptGdpr"
              @change="updateAcceptGdpr($event.target.checked)" required
              class="consentCheckbox text-6xl grid grid-cols-2 gap-[2vw] w-[5vw] h-[5vw]">
          </div>

          <label for="gdpr" class="ms-[2vw] text-[4vw] text-[#101B53] underline">
            <a
              href="https://kafeaterra.gr/%ce%bf%cf%81%ce%bf%ce%b9-%ce%ba%ce%b1%ce%b9-%cf%80%cf%81%ce%bf%cf%8b%cf%80%ce%bf%ce%b8%ce%b5%cf%83%ce%b5%ce%b9%cf%82/%cf%80%ce%bf%ce%bb%ce%b9%cf%84%ce%b9%ce%ba%ce%b7-%ce%b4%ce%b5%ce%b4%ce%bf%ce%bc%ce%b5%ce%bd%cf%89%ce%bd/"
              target="_blank"
              rel="noopener noreferrer"
              @click.stop
            >
              {{ $t('formPage.gdprPlaceholder') }}
            </a>
          </label>
        </div>

        <div class="newsletterLabel flex mb-[70px]">
          <div class="flex">
            <input id="newsletter" type="checkbox" name="newsletter" :checked="userInfo.newsletter"
              @change="updateNewsletter($event.target.checked)"
              class="consentCheckbox text-6xl grid grid-cols-2 gap-[2vw] w-[5vw] h-[5vw]">
          </div>

          <label for="newsletter" class="ms-[2vw] text-[4vw] text-[#101B53]">
            {{ $t('formPage.newsletterPlaceholder') }}
          </label>
        </div>
        <button type="submit" :disabled="!isFormValid"
          class="text-[4.5vw] text-white bg-[#101B53] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[100vw] w-full px-5 py-3 text-center">
          {{ $t('formPage.submitButton') }}
        </button>
        </form>
      </div>
    </div>
  </div>

  <div v-if="toastMessage" class="fixed bottom-5 left-1/2 transform -translate-x-1/2">
    <div id="toast-warning" class="flex items-center p-4 w-auto max-w-full text-gray-500 bg-white rounded-lg shadow-lg"
      role="alert">
      <div
        class="inline-flex items-center justify-center flex-shrink-0 w-[3vw] h-[3vw] text-yellow-500 bg-yellow-100 rounded-lg">
        <svg class="w-[2.5vw] h-[2.5vw]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
          viewBox="0 0 20 20">
          <path
            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z" />
        </svg>
        <span class="sr-only">Warning icon</span>

      </div>
      <div class="ml-3 text-[4vw] font-light uppercase whitespace-nowrap">{{ toastMessage }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: Object
  },
  data() {
    return {
      showImage: false,
      toastMessage: '',
      phoneTouched: false,
      emailTouched: false,
    };
  },
  mounted() {
    this.showImage = true;
  },
  computed: {
    isPhoneValid() {
      return this.isPhoneNumberValid(this.userInfo.phone);
    },
    isEmailValid() {
      return this.isEmailAddressValid(this.userInfo.email);
    },
    isFormValid() {
      return this.userInfo.fname.trim() !== '' &&
        this.userInfo.lname.trim() !== '' &&
        this.isEmailValid &&
        this.isPhoneValid &&
        this.userInfo.acceptGdpr;
    },
  },
  methods: {
    updateFName(value) {
      this.$emit('update-user-info', { ...this.userInfo, fname: value });
    },
    updateLName(value) {
      this.$emit('update-user-info', { ...this.userInfo, lname: value });
    },
    updatePhone(event) {
      const value = event.target.value;
      this.phoneTouched = true;
      event.target.setCustomValidity(
        this.isPhoneNumberValid(value) ? '' : this.$t('formPage.phoneError')
      );
      this.$emit('update-user-info', { ...this.userInfo, phone: value });
    },
    isPhoneNumberValid(value) {
      if (typeof value !== 'string') {
        return false;
      }

      const phone = value.trim();
      const digitCount = (phone.match(/\d/g) || []).length;

      return /^\+?[0-9 ()-]+$/.test(phone) &&
        digitCount >= 7 &&
        digitCount <= 15;
    },
    validatePhoneField() {
      this.phoneTouched = true;
      this.$refs.phoneInput.setCustomValidity(
        this.isPhoneValid ? '' : this.$t('formPage.phoneError')
      );
    },
    updateEmail(event) {
      const value = event.target.value;
      this.emailTouched = true;
      event.target.setCustomValidity(
        this.isEmailAddressValid(value) ? '' : this.$t('formPage.emailError')
      );
      this.$emit('update-user-info', { ...this.userInfo, email: value });
    },
    isEmailAddressValid(value) {
      if (typeof value !== 'string') {
        return false;
      }

      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
    },
    validateEmailField() {
      this.emailTouched = true;
      this.$refs.emailInput.setCustomValidity(
        this.isEmailValid ? '' : this.$t('formPage.emailError')
      );
    },
    updateAcceptGdpr(checked) {
      this.$emit('update-user-info', { ...this.userInfo, acceptGdpr: checked });
    },
    updateNewsletter(checked) {
      this.$emit('update-user-info', { ...this.userInfo, newsletter: checked });
    },
    showToast(message) {
      this.toastMessage = message;
      setTimeout(() => {
        this.toastMessage = '';
      }, 3000);
    },
    async handleSubmit() {
      if (!this.isFormValid) {
        this.validatePhoneField();
        this.validateEmailField();
        this.$refs.contactForm.reportValidity();
        return;
      }

      const now = new Date()
      const dataForCollectionData = {
        fname: this.userInfo.fname,
        lname: this.userInfo.lname,
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        newsletter: this.userInfo.newsletter,
        expo: 'CoffeeFestivalSept2026',
        date: (now.getTime())
      }
      await fetch('https://kafea-terra-form-api.ocm.workers.dev/', {
        method: 'POST',
        body: JSON.stringify(dataForCollectionData),
        headers: { 'content-type': 'application/json' }
      })
        .then(response => {
          if (this.isFormValid && (response.status !== 409 && response.status !== 404 && response.status !== 500)) {
            this.$emit('submit-user-info');
          } else if (response.status === 409) {
            this.showToast(this.$t('formPage.toastMsg'));
          }
        })
        .catch(error => console.error('Error upload user:', error));
    },
  }
};
</script>

<style scoped>
.matching-form-content {
  width: 100%;
  margin: min(6.0648vw, 131px) auto 0;
}

.containerPage {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

  @media only screen and (max-width: 1000px) {
    gap: 20px;
  }

  @media only screen and (max-width: 750px) {
    gap: 10px;
  }
}

.gifts {
  display: block;
  width: min(80.3241vw, 1735px);
  height: min(41.8056vw, 903px);
  margin-inline: auto;
  object-fit: contain;
}

.containerForm {
  background: white;
  border-radius: 20px;
  padding: min(5.6019vw, 121px) min(6.9444vw, 150px);
  margin-top: min(7.0370vw, 152px);
  margin-bottom: 100px;
  width: 100%;

  @media only screen and (max-width: 1000px) {
    margin-bottom: 100px;
  }

  @media only screen and (max-width: 750px) {
    margin-bottom: 50px;
  }
}

.formTitle {
  text-align: left;
  font-size: min(5.3704vw, 116px);
  font-weight: 500;
  line-height: min(6.0648vw, 131px);
  color: #101B53;
  text-transform: uppercase;
  padding-bottom: min(3.9352vw, 85px);
}

.containerForm input:not([type='checkbox']) {
  font-family: 'DrukFont', sans-serif;
  font-size: min(4.3519vw, 94px);
  font-weight: 500;
  line-height: min(4.9074vw, 106px);
  letter-spacing: 0;
  color: #101B53;
  text-transform: uppercase;
}

.containerForm input:not([type='checkbox'])::placeholder {
  color: #101B53;
  opacity: 0.21;
}

.gdprLabel,
.newsletterLabel {
  font-family: "CorporateFont", sans-serif;

  @media only screen and (max-width: 600px) {
    input {
      font-size: 1.75rem;
    }
  }
}

.gdprLabel {
  margin-bottom: min(1.8519vw, 40px);
}

.newsletterLabel {
  margin-bottom: min(5.6019vw, 121px);
}

.gdprLabel label,
.newsletterLabel label {
  font-family: 'CorporateFont', sans-serif;
  font-size: min(3.5185vw, 76px);
  font-weight: 300;
  line-height: min(4.2130vw, 91px);
}

.containerForm button[type='submit'] {
  font-family: 'DrukFont', sans-serif;
  font-size: min(4.3519vw, 94px);
  font-weight: 500;
  line-height: min(4.9074vw, 106px);
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background-color: #ccc;
}

.consentCheckbox {
  appearance: none;
  background: #F0F0F0;
  border: 0.25vw solid #101B53;
  border-radius: 50%;
  cursor: pointer;
}

.consentCheckbox:checked {
  background: radial-gradient(circle, #101B53 0 38%, #F0F0F0 42%);
}

.consentCheckbox:focus,
.consentCheckbox:focus-visible {
  box-shadow: none;
  outline: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media only screen and (max-width: 400px) {
  #toast-warning {
    padding: 0.5rem;
  }
}
</style>
